<template>
  <div class="multiUploadImg-container">
    <el-upload
      drag
      :action="uploadImg"
      ref="multiUploadImg"
      accept=".webp,.bmp,.pcx,.tif,.gif,.jpeg,.tag,.exif,.fpx,.svg,.png,.ico,.jpg"
      :multiple="true"
      :limit="limit"
      :file-list="old"
      :on-success="successMultiImg"
      :on-exceed="exceedMultiImg"
      :on-error="errorMultiImg"
      :on-preview="openViewer"
      :before-remove="beforeRemove"
      :on-remove="removeMultiImg">
      <div style="padding-top: 10px">
        <i class="el-icon-plus" style="font-size: 20px"></i>
        <div>可将图片拖入此处</div>
      </div>

    </el-upload>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[dialogImageUrl]">
    </el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'MultiDragImg',
  components: { ElImageViewer },
  props: {
    value: {
      type: Array
    },
    limit: {
      type: Number,
      default: 9
    },
    size: {
      type: String,
      default: 'lg'
    },
    old: {
      type: Array
    }
  },
  data() {
    return {
      uploadImg: process.env.VUE_APP_BASE_API + '/fileUpload/uploadImg',
      imgids: [],
      showViewer: false,
      dialogImageUrl: ''
    }
  },
  created() {
    this.boxsize += this.size
    if (this.old !== undefined) {
      if (this.old.length > 0) {
        for (let i of this.old) {
          this.imgids.push(i.id)
        }
        this.$emit('input', this.imgids)
      }
    }
  },
  methods: {
    exceedMultiImg(files, fileList) {
      this.$message({
        type: 'error',
        message: '最多上传' + this.limit + '张图片'
      })
    },
    errorMultiImg() {
      this.$message({
        type: 'error',
        message: '图片上传失败，请稍后重试'
      })
    },
    successMultiImg(response, file, fileList) {
      if (response.success) {
        this.imgids.push(response.data.dImgid)
        this.$emit('input', this.imgids)
      } else {
        this.$message({
          type: 'error',
          message: response.msg
        })
      }
    },
    beforeRemove(file, fileList) {
      return new Promise((resolve, reject) => {
        this.$confirm('图片已上传，确认要删除它吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    removeMultiImg(file, fileList) {
      if (file.data !== null && file.data !== undefined) {
        const i = this.imgids.indexOf(file.response.data.dImgid)
        if (i !== -1) {
          this.imgids.splice(i, 1)
        }
      } else if (file.response !== null && file.response !== undefined && file.response.data !== null && file.response.data !== undefined) {
        const i = this.imgids.indexOf(file.response.data.dImgid)
        if (i !== -1) {
          this.imgids.splice(i, 1)
        }
      } else {
        if (file.id !== null && file.id !== undefined) {
          const i = this.imgids.indexOf(file.id)
          if (i !== -1) {
            this.imgids.splice(i, 1)
          }
        }
      }
      this.$emit('input', this.imgids)
    },
    clearMultiImg() {
      this.imgids = []
      this.$emit('input', this.imgids)
      this.$refs['multiUploadImg'].clearFiles()
    },
    openViewer(file) {
      this.dialogImageUrl = file.url
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>
<style>
   .el-upload-dragger {
     background-color: #fff;
     border: 1px dashed #d9d9d9;
     border-radius: 6px;
     -webkit-box-sizing: border-box;
     box-sizing: border-box;
     width: 150px;
     height: 80px;
     text-align: center;
     position: relative;
     overflow: hidden;
   }
   .el-upload--picture-card {
     background-color: #fbfdff;
     border: 0px dashed #c0ccda;
     border-radius: 6px;
     -webkit-box-sizing: border-box;
     box-sizing: border-box;
     width: 148px;
     height: 148px;
     line-height: 146px;
     vertical-align: top;
   }
</style>
